import { closeHubSpotWidgetChat, hideHubSpotWidget, showHubSpotWidget } from '../utils/hubspot';
import useEffectOnce from './use-effect-once';

const onMessageReceived = (event: MessageEvent<string>) => {
  /**
   * HubSpot API: https://legacydocs.hubspot.com/docs/methods/conversations_api/widget_events
   * The API do not have a native way to listen to chat opened or closed events.
   * Instead we are relying on listening on message-events and check to see if the event comes from HubSpot.
   * Taken inspiration from: https://gist.github.com/robwent/0375f2926d175d99224d8725d6e39d7b
   * */
  if (event.origin == 'https://app.hubspot.com') {
    try {
      const data = JSON.parse(event.data);
      const isHubSpotChatOpen = data?.data?.isOpen;

      // Check if HubSpot isOpen event is defined and if it was set to false (Happens when using the Close-button from the widget)
      if (isHubSpotChatOpen !== undefined && !isHubSpotChatOpen) {
        closeHubSpotWidgetChat();
        hideHubSpotWidget();
      }
    } catch (e) {
      return;
    }
  }
};

const waitUntilElementLoaded = async (selector: string) => {
  while (document.querySelector(selector) === null) {
    await new Promise((resolve) => requestAnimationFrame(resolve));
  }
  return document.querySelector(selector);
};

export const useHideHubspotWidgetOnMount = () => {
  useEffectOnce(() => {
    window.addEventListener('message', onMessageReceived);

    waitUntilElementLoaded('#hubspot-messages-iframe-container').then(() => {
      hideHubSpotWidget();
    });

    return () => {
      window.removeEventListener('message', onMessageReceived);

      waitUntilElementLoaded('#hubspot-messages-iframe-container').then(() => {
        showHubSpotWidget();
      });
    };
  });
};
